import React from "react";

const ContactSection = () => {
  return (
    <section className="bg-[#153280] text-white px-8 py-16 padding-bottm-contact">
      <div className="container mx-auto text-center">
        <h2
          className="headline-contact"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          Let’s discuss your next project.
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start company-contact">
          {/* Map */}
          <div
            className="w-full rounded-xl overflow-hidden shadow-lg"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <iframe
              title="Company Location"
              src="https://www.google.com/maps?q=Ganesh+Bhuvan,+Girgaon,+Mumbai,+Maharashtra,+India&output=embed"
              className="border-0 map-location"
              loading="lazy"
              allowFullScreen
            ></iframe>
          </div>

          {/* Contact Info */}
          <div
            className="text-left space-y-6"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            {/* Address */}
            <div className="office-address">
              <h4>Office Address</h4>
              <p className="leading-relaxed">
                Bhagwati Engineering Contractors
                <br />
                Floor GRD Godwan-62, Madhuli Building,
                <br />
                Vitthalbhai Patel Road Girgaon,
                <br />
                Mumbai – 400004, Maharashtra, India
              </p>
            </div>

            {/* Call */}
            <div className="office-address">
              <h4>Call Us</h4>
              <p>+91 93231 06844 – Ramkar Pandey</p>
              <p>+91 82917 24184 – Abhishek Pandey</p>
            </div>

            {/* Email */}
            <div className="office-address">
              <h4>Email Us</h4>
              <p>bhagwatiengineering76@gmail.com</p>
            </div>

            {/* GSTIN */}
            <div className="office-address">
              <h4>GSTIN</h4>
              <p>27AARFB6453D2ZA</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
